module.exports = "/_next/static/images/kr-94941e047e194c9e95bdc44e8256ad0f.svg";